/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'กำลังโหลด...',
	'dlg_close': 'ปิด',
	'dlg_ok': 'ตกลง',
	'dlg_cancel': 'ยกเลิก',
	'dlg_back': 'ย้อนกลับ',

	// Slider
	'sliderRegionLabel': 'ตัวควบคุมสไลเดอร์ ใช้ลูกศรขวาและซ้ายเพื่อย้ายตัวจัดการสไลเดอร์',
	'sliderHandleLabel': 'ตัวจัดการสไลเดอร์',
	'a11ySliderHandleLabel': 'ตัวจัดการสไลเดอร์ %{sliderValue}',
	'sliderInputLabel': 'ค่า',

	// Side bar
	'sidebarAdd': 'เพิ่ม',
	'clearTextFilterValue': 'เคลียร์',
	'missingDataSetData': 'ข้อมูลสำหรับชุดข้อมูลนี้ไม่พร้อมใช้งาน รีเฟรชชุดข้อมูล หรือติดต่อผู้ดูแลระบบของคุณสำหรับการเข้าถึงแหล่งข้อมูล',

	// Toolbar
	'toolbarRegionLabel': 'แถบเครื่องมือ',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'ตระกูลของฟอนต์',
	'fontSizeSelect': 'ขนาดของฟอนต์',
	'bold': 'ตัวหนา',
	'italic': 'ตัวเอียง',
	'underline': 'ขีดเส้นใต้',
	'justifyLeft': 'จัดวางชิดซ้าย',
	'justifyCenter': 'จัดวางไว้กึ่งกลาง',
	'justifyRight': 'จัดวางชิดขวา',
	'insertOrderedList': 'รายการแบบเรียงลำดับ',
	'insertUnorderedList': 'รายการแบบไม่เรียงลำดับ',
	'fontColorPicker': 'ตัวเลือกสี',
	'textWrap': 'ตัดข้อความ',
	'restore': 'เรียกคืนค่าดีฟอลต์',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'จำนวนของผลลัพธ์',
	'topbottomPercentLabel': 'เปอร์เซ็นต์',
	'topbottomNumberOfResultsLimit': 'ค่าสามารถเป็นค่า %{lower} - %{higher}',
	'topbottomSelectOption': 'อ็อพชันด้านบนหรือด้านล่าง',
	'topbottomOptionLabel': 'แสดง',
	'searchByLabel': 'โดย',
	'searchNoMatches': 'ไม่พบรายการที่ตรงกัน',
	'topbottomRankColumnLabel': 'เพิ่มคอลัมน์การจัดอันดับเข้ากับตาราง',
	'topbottomNone': 'ไม่มี',
	'topCount': 'การนับด้านบน',
	'topPercent': 'ด้านบน %',
	'bottomCount': 'การนับด้านล่าง',
	'bottomPercent': 'ด้านล่าง %',
	'searchColumn': 'ค้นหาคอลัมน์',
	'searchColumnAriaLabel': 'ค้นหาคอลัมน์ พิมพ์ชื่อของคอลัมน์ที่จะค้นหา จากนั้น ใช้ลูกศรลงเพื่อค้นหาคอลัมน์ในรายการ',
	'rankColumnLabel': 'อันดับ (%{columnLabel})',
	'topbottomClearLabel': 'เคลียร์',

	// Format
	'formatAuto': 'อัตโนมัติ',
	'formatConvertPercent': 'แปลงทศนิยมเป็นเปอร์เซ็นต์',
	'formatAbbreviate': 'ย่อ',
	'formatUseGrouping': 'ใช้ตัวคั่นหลักพัน',
	'dateStyle': 'สไตล์วันที่',
	'dateTimeStyle': 'สไตล์ของวันที่/เวลา',
	'formatMissingValueCharactersInfo': 'อักขระของค่าที่หายไประบุอักขระที่ต้องแสดงเมื่อค่าหายไป',
	'currencySymbolLabel': 'สัญลักษณ์สกุลเงิน',
	'customSymbolPlaceholder': 'เพิ่มสัญลักษณ์',
	'customSymbolLabelInfo': 'ระบุอักขระตัวเดียวหรือหลายตัวที่จะใช้เป็นสัญลักษณ์แบบกำหนดเอง สัญลักษณ์นี้จะนำหน้าหมายเลขและสัญลักษณ์ใด ๆ',
	'numberLabel': 'เลเบลหมายเลข',
	'numberPositionLabel': 'ตำแหน่งเลเบล',
	'numberLabelInfo': 'ระบุเลเบลสำหรับหมายเลขที่จัดรูปแบบและวางไว้หน้าหรือต่อท้ายขึ้นอยู่กับตำแหน่งของเลเบล',
	'nullValueDefault': '<ดีฟอลต์>',
	'nullValueContent': '(ไม่มีค่า)',
	'default': 'ดีฟอลต์',
	'beginning': 'เริ่มต้น',
	'end': 'สิ้นสุด',

	// More data indicator
	'moreDataIndicator': 'ข้อมูลของคุณถูกตัดที่ %{threshold} ไอเท็ม ใช้กับตัวกรองเพื่อแสดงข้อมูลให้น้อยลง',

	// Expanded View / Focus mode
	'evCollapse': 'ยุบ',
	'duplicate': 'ทำซ้ำ',
	'copyOf': 'สำเนาของ %{name}',
	'unableToDuplicateBoard': 'ไม่สามารถทำสำเนา "%{name}"',

	// Widget list
	'errorLoadingWidgetList': 'เราไม่สามารถโหลดอ็อบเจ็กต์',

	// Custom widgets
	'customWidget': 'วิดเจ็ตแบบกำหนดเอง'
});
